// TODO ? Rename Config -> Environment / EnvironmentConfig ?

export class Config {

    public environment: string;
    public restBaseUrl: string;
    public realtyUrl: string;
    public authenticationUrl: string;
    public client: string;

    public loadFromJSON(configJSON: any): void {
        this.environment = configJSON['environment'];
        this.restBaseUrl = configJSON['restBaseUrl'];
        this.realtyUrl = configJSON['realtyUrl'];
        this.authenticationUrl = configJSON['authenticationUrl'];
        this.client = configJSON['client'];
    }
}

export default new Config();



/** WEBPACK FOOTER **
 ** ./src/utility/Config.ts
 **/